const REQUEST_STATUS = {
  IN_PROGRESS : 'IN_PROGRESS',
  SUCCEEDED   : 'SUCCEEDED',
  FAILED      : 'FAILED'
};

export default REQUEST_STATUS;
